export interface EventMessage {
  // Operator-controlled on/off switch, independent of whether text is present.
  active: boolean;
  // Spanish message shown to customers on the event's public surfaces.
  message: string;
}

export const EVENT_MESSAGES_COLLECTION = 'event_messages';
